import {getQuery, postQuery, putQuery, removeQuery} from "@/modules/common/utils";

const get = (params = {}) => {
  params.new_api = true
  return getQuery('/business/payments/v1/products', params)
}

const create = (params = {}) => {
  params.new_api = true
  return postQuery('/business/payments/v1/products', params)
}

const edit  = (params = {}) => {
  params.new_api = true
  const productId = params.product.id
  delete params.product.id
  return putQuery(`/business/payments/v1/products/${productId}`, params)
}

const remove =  (productId, params = {}) => {
  params.new_api = true
  return removeQuery(`/business/payments/v1/products/${productId}`, params)
}

const show =  (productId, params = {}) => {
  params.new_api = true
  return getQuery(`/business/payments/v1/products/${productId}`, params)
}

export const productService = {
  get,
  create,
  edit,
  remove,
  show
}
